import { useEffect } from "react";
import { USER_TYPES } from "@/shared/constants";
import { create } from "zustand";
import { User } from "@/shared/types";
import { getAccessToken } from "@/shared/auth/authTokens";

interface CurrentTalentState {
  user: User | null;
  setUser: (user: User | null) => void;
  authToken: null | string;
  setAuthToken: (token: string | null) => void;
  resetUser: () => void;
}

const useAuthStore = create<CurrentTalentState>()((set) => ({
  user: null,
  setUser: (user) =>
    set(() => ({
      user,
    })),
  authToken: null,
  setAuthToken: (token) =>
    set(() => ({
      authToken: token,
    })),
  resetUser: () => set(() => ({ user: null, authToken: null })),
}));

export function useAuth() {
  const { user, setUser, authToken, setAuthToken, resetUser } = useAuthStore();
  useEffect(() => {
    if (!authToken) {
      const token = getAccessToken();
      if (token) setAuthToken(token);
    }
  }, [authToken, setAuthToken]);

  return {
    accessToken: authToken,
        userInfo: user,
        isUserLogin: authToken && user?.account_type === USER_TYPES.USER,
        isTalentLogin: authToken && user?.account_type === USER_TYPES.TALENT,
        isOrganizationLogin: authToken && user?.account_type === USER_TYPES.ORGANIZATION,
        isBusinessLogin: authToken && user?.account_type === "Business",
    setUser,
    setAuthToken,
    resetUser,
  };
}
